import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { GenericPostsDto } from '../../common/general-types/super-social.dto';
import { ImageService } from '../../services/image/image.service';
import { FormatService } from '../../common/format/format.service';

@Component({
  selector: 'atom-media-viewer-simpler',
  standalone: true,
  imports: [],
  templateUrl: './media-viewer-simpler.component.html',
  styleUrl: './media-viewer-simpler.component.css'
})
export class MediaViewerSimplerComponent implements OnInit {

  @Input('src') src: string | undefined;
  @Input('inputClass') inputClass: string | undefined;
  @Input('h') imageHeight: string | undefined;
  @Input('w') imageWidth: string | undefined;
  @Input('radius') imageRadius: string | undefined;

  @Input('aspect') aspect: string | undefined;
  @Input('fit') fit: string | undefined = "cover";

  @Input('post') post: GenericPostsDto | undefined;

  isLoading = signal<boolean | undefined>(undefined);
  loadError = signal<string | undefined>(undefined);

  imageFormats: string[] = ["jpg", "jpeg", "png", "gif", "webp", "svg", "avif"];
  videoFormats: string[] = ["mp4", "webm", "ogg", "mov", "avi", "wmv", "flv", "mkv", "m4v"];

  isImage = signal<boolean>(false);
  isVideo = signal<boolean>(false);

  /** Services */
  public imageService = inject(ImageService);
  public formatService = inject(FormatService);
  /** Services - END */

  ngOnInit(): void {
    this.isLoading.set(true);
    this.loadError.set(undefined);
    this.setupComponent();
  }

  setupComponent() {
    if (!this.src) {
      this.isLoading.set(false);
      this.loadError.set("no url provided");
      return;
    } else {

      // Check if the src contains any image format
      const detectedFormat = this.detectImageFormat(this.src);

      if (detectedFormat && this.videoFormats.includes(detectedFormat)) {
        this.isVideo.set(true);
        this.initVideo();
      } else {
        // Either a recognised image extension, or a URL with no detectable
        // extension (e.g. CDN/S3 thumbnail URLs, signed URLs, encoded paths).
        // Default to rendering as an image; the <img> (error) handler falls
        // back to the placeholder if it genuinely fails to load.
        this.isImage.set(true);
        this.initImage();
      }
    }
  }

  /**
  * Searches the src string for each item in the imageFormats array
  * @param src The source URL string to search
  * @returns The detected format or null if no format is found
  */
  detectImageFormat(src: string): string | null {
    if (!src) return null;

    // Convert to lowercase for case-insensitive matching
    const lowerSrc = src.toLowerCase();

    // Search for each format in the imageFormats array
    for (const format of this.imageFormats) {
      if (lowerSrc.includes(`.${format}`)) {
        return format;
      }
    }

    // Search for each format in the videoFormats array
    for (const format of this.videoFormats) {
      if (lowerSrc.includes(`.${format}`)) {
        return format;
      }
    }
    return null;
  }

  initImage() {
    this.isLoading.set(true);
    this.loadError.set(undefined);
  }

  initVideo() {
    this.isLoading.set(false);
    this.loadError.set(undefined);
  }

  hideLoader() {
    this.isLoading.set(false);
    this.loadError.set(undefined);
  }

  showError(event: any) {
    this.isLoading.set(false);
    this.loadError.set(JSON.stringify(event));
    // console.error('############## Error loading image: ', event);
  }

  getDimensions() {
    let imageClass: string = '';
    if (this.imageHeight && this.imageWidth) {
      imageClass = `h-${this.imageHeight} w-${this.imageWidth}`;
    } else if (this.imageHeight) {
      imageClass = `h-${this.imageHeight} w-auto`;
    } else if (this.imageWidth) {
      imageClass = `w-${this.imageWidth} h-full`;
      imageClass = `w-${this.imageWidth}`;
    } else {
      imageClass = 'h-full w-full object-cover';
    }

    if (this.imageRadius) {
      imageClass = `${imageClass} rounded-${this.imageRadius}`;
    }

    if (this.fit) {
      imageClass = `${imageClass} object-${this.fit}`;
    }

    if (this.aspect) {
      imageClass = `${imageClass} ${this.aspect}`
    }

    // return imageClass;
    return imageClass + " " + this.inputClass;

    // return "h-full w-full object-cover";
  }

  getAspect() {
    if (this.aspect) {
      return this.aspect
    }
    return "aspect-h-16 aspect-w-9"
  }
}
